export enum ApplicationType {
  INTERNAL = 0,
  EXTERNAL = 1
}
